const readTotalCounts = `
query readTotalCounts{
  individuals(where:{type:CUSTOMER}){
    totalCount
  }
  companies(where:{type:CUSTOMER}){
    totalCount
  }
  policies(where: { status_in: ["ISSUED","CANCELLED"] }){
      totalCount
  }
  quotes: policies(where: { status_in: ["QUOTING", "REJECTED", null] }){
    totalCount
  }
  cases {
    totalCount
  }
}
`

const readOccurences = `
query readOccurences{
  individuals(where:{type:CUSTOMER}){
    list{
      createdAt
    }
  }
  companies(where:{type:CUSTOMER}){
    list{
      createdAt
    }
  }
  policies(where: { status_in: ["ISSUED","CANCELLED"] }){
      list{
          createdAt
      }
  }
  quotes: policies(where: { status_in: ["QUOTING", "REJECTED", null] }){
    list{
        createdAt
    }
  }
}
`

const query = {
	readTotalCounts,
	readOccurences
}

const mutation = {}

export { query, mutation }
